
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'embedded-viral-link-ui',
  currentProjectVersion: 'static-1.6281',
  depVersions: {
  "embedded-viral-link-ui": "static-1.6281",
  "head-dlb": "static-1.4921",
  "hs-test-utils": "static-1.7900",
  "hubspot-dlb": "static-2.1828",
  "HubStyleTokens": "static-2-me-set-font-family-mixin.6",
  "I18n": "static-7.1598",
  "jasmine-runner": "static-1.6358",
  "quartz": "static-1.6851",
  "quartz-core": "static-1.6070",
  "react-dlb": "static-1.76",
  "webpack-env": "static-1.54",
  "cssUtils": "static-1.764",
  "enviro": "static-4.425",
  "foundations-components": "static-1.7697",
  "history": "static-4.47",
  "hub-http": "static-1.6107",
  "hubspot-url-utils": "static-1.4034",
  "HubStyle": "static-2-me-set-font-family-mixin.6",
  "icons": "static-2-me-set-font-family-mixin.2",
  "immer": "static-1.33",
  "laboratory-lib": "static-3.7048",
  "PortalIdParser": "static-2.386",
  "quartz-config": "static-1.629",
  "quartz-routing": "static-1.281",
  "quick-fetch": "static-1.3822",
  "react": "static-7.184",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.69",
  "react-rhumb": "static-1.16542",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5255",
  "react-virtualized": "static-2.97",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "signup-constants": "static-1.18631",
  "signup-ui-lego-core": "static-1.20641",
  "styled-components": "static-2.87",
  "StyleGuideUI": "static-3.485",
  "ui-addon-react-router-dom": "static-1.9433",
  "ui-images": "static-2-me-set-font-family-mixin.2",
  "UIComponents": "static-3-me-set-font-family-mixin.6",
  "usage-tracker": "static-1.7224",
  "usage-tracker-core": "static-1.7074",
  "viral-links-lib": "static-1.6927",
  "hs-promise-rejection-tracking": "static-1.5473",
  "raven": "static-3.5808",
  "raven-hubspot": "static-1.6115",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.76",
  "metrics-js": "static-1.9522",
  "bend-plugin-trellis-migration": "static-1.3313",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3128",
  "quartz-webpack": "static-1.3075",
  "HeadJS": "static-2.732",
  "framer-motion": "static-1.70",
  "hs-test-utils-bend-plugin": "static-1.3011",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "foundations-theming": "static-1.4300",
  "i18n-data": "static-1.218",
  "moment-timezone": "static-5.81",
  "jasmine": "static-4.4213",
  "dispatcher": "static-1.134",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.816",
  "hubspotter-http": "static-1.4559",
  "mobile-manifest-mixins": "static-1.506",
  "module-federation": "static-1.21",
  "quartz-auth": "static-1.526",
  "quartz-head": "static-1.516",
  "quartz-i18n": "static-1.526",
  "quartz-test": "static-1.526",
  "quartz-tracking": "static-1.230",
  "ui-fonts": "static-1-me-set-font-family-mixin.6",
  "usage-tracker-container": "static-1.7214",
  "sassPrefix": "static-1.153",
  "bend-plugin-foundations-components": "static-1.3966",
  "floating-ui": "static-1.54",
  "foundations-assets": "static-1.4733",
  "foundations-theming-specialty": "static-1.2016",
  "hs-story-utils": "static-1.9317",
  "react-aria": "static-1.64",
  "tanstack-table": "static-1.53",
  "trellis-assets": "static-1.1487",
  "superstore": "static-1.4657",
  "csstype": "static-1.50",
  "rpc-client-utils": "static-1.4532",
  "emoji-regex": "static-1.7",
  "PatternValidationJS": "static-1.437",
  "signup-ui-url-generator": "static-2.7928",
  "bender-build-tools": "static-1.3056",
  "bend-plugin-foundations-theming": "static-1.2783",
  "foundations-theming-base": "static-1.3285",
  "stylex": "static-1.30",
  "hub-http-shared-msw-handlers": "static-1.9704",
  "hubspotter-http-shared-msw-handlers": "static-1.9702",
  "usage-tracker-session-replay": "static-1.4910",
  "chirp-fetch": "static-1.1770",
  "ts-schema": "static-1.3986",
  "amplitude-session-replay-browser": "static-1.58"
},
  depPathPrefixes: {
  "embedded-viral-link-ui": "/embedded-viral-link-ui/static-1.6281",
  "head-dlb": "/head-dlb/static-1.4921",
  "hs-test-utils": "/hs-test-utils/static-1.7900",
  "hubspot-dlb": "/hubspot-dlb/static-2.1828",
  "HubStyleTokens": "/HubStyleTokens/static-2-me-set-font-family-mixin.6",
  "I18n": "/I18n/static-7.1598",
  "jasmine-runner": "/jasmine-runner/static-1.6358",
  "quartz": "/quartz/static-1.6851",
  "quartz-core": "/quartz-core/static-1.6070",
  "react-dlb": "/react-dlb/static-1.76",
  "webpack-env": "/webpack-env/static-1.54",
  "cssUtils": "/cssUtils/static-1.764",
  "enviro": "/enviro/static-4.425",
  "foundations-components": "/foundations-components/static-1.7697",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6107",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4034",
  "HubStyle": "/HubStyle/static-2-me-set-font-family-mixin.6",
  "icons": "/icons/static-2-me-set-font-family-mixin.2",
  "immer": "/immer/static-1.33",
  "laboratory-lib": "/laboratory-lib/static-3.7048",
  "PortalIdParser": "/PortalIdParser/static-2.386",
  "quartz-config": "/quartz-config/static-1.629",
  "quartz-routing": "/quartz-routing/static-1.281",
  "quick-fetch": "/quick-fetch/static-1.3822",
  "react": "/react/static-7.184",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.69",
  "react-rhumb": "/react-rhumb/static-1.16542",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5255",
  "react-virtualized": "/react-virtualized/static-2.97",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "signup-constants": "/signup-constants/static-1.18631",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20641",
  "styled-components": "/styled-components/static-2.87",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9433",
  "ui-images": "/ui-images/static-2-me-set-font-family-mixin.2",
  "UIComponents": "/UIComponents/static-3-me-set-font-family-mixin.6",
  "usage-tracker": "/usage-tracker/static-1.7224",
  "usage-tracker-core": "/usage-tracker-core/static-1.7074",
  "viral-links-lib": "/viral-links-lib/static-1.6927",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5473",
  "raven": "/raven/static-3.5808",
  "raven-hubspot": "/raven-hubspot/static-1.6115",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.76",
  "metrics-js": "/metrics-js/static-1.9522",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3313",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3128",
  "quartz-webpack": "/quartz-webpack/static-1.3075",
  "HeadJS": "/HeadJS/static-2.732",
  "framer-motion": "/framer-motion/static-1.70",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3011",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "foundations-theming": "/foundations-theming/static-1.4300",
  "i18n-data": "/i18n-data/static-1.218",
  "moment-timezone": "/moment-timezone/static-5.81",
  "jasmine": "/jasmine/static-4.4213",
  "dispatcher": "/dispatcher/static-1.134",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.816",
  "hubspotter-http": "/hubspotter-http/static-1.4559",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.506",
  "module-federation": "/module-federation/static-1.21",
  "quartz-auth": "/quartz-auth/static-1.526",
  "quartz-head": "/quartz-head/static-1.516",
  "quartz-i18n": "/quartz-i18n/static-1.526",
  "quartz-test": "/quartz-test/static-1.526",
  "quartz-tracking": "/quartz-tracking/static-1.230",
  "ui-fonts": "/ui-fonts/static-1-me-set-font-family-mixin.6",
  "usage-tracker-container": "/usage-tracker-container/static-1.7214",
  "sassPrefix": "/sassPrefix/static-1.153",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3966",
  "floating-ui": "/floating-ui/static-1.54",
  "foundations-assets": "/foundations-assets/static-1.4733",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2016",
  "hs-story-utils": "/hs-story-utils/static-1.9317",
  "react-aria": "/react-aria/static-1.64",
  "tanstack-table": "/tanstack-table/static-1.53",
  "trellis-assets": "/trellis-assets/static-1.1487",
  "superstore": "/superstore/static-1.4657",
  "csstype": "/csstype/static-1.50",
  "rpc-client-utils": "/rpc-client-utils/static-1.4532",
  "emoji-regex": "/emoji-regex/static-1.7",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7928",
  "bender-build-tools": "/bender-build-tools/static-1.3056",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2783",
  "foundations-theming-base": "/foundations-theming-base/static-1.3285",
  "stylex": "/stylex/static-1.30",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9704",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9702",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4910",
  "chirp-fetch": "/chirp-fetch/static-1.1770",
  "ts-schema": "/ts-schema/static-1.3986",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58"
}
};
